import { CommonModule } from '@angular/common';
import { MaskitoDirective } from '@maskito/angular';
import { ChangeDetectionStrategy, Component, forwardRef } from '@angular/core';
import { PhoneCountryCodeNumberInputComponent } from '../../../../form-components/phone-country-code/phone-number-input/phone-country-code-number-input.component';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-review-phone-country-code-number-input',
  standalone: true,
  imports: [CommonModule, MaskitoDirective],
  templateUrl: './review-phone-country-code-number-input.component.html',
  styleUrls: ['./review-phone-country-code-number-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ReviewPhoneCountryCodeNumberInputComponent),
      multi: true
    }
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReviewPhoneCountryCodeNumberInputComponent extends PhoneCountryCodeNumberInputComponent {}
